import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import edit from '../../../../assets/images/icons/edit.svg';
import trash from '../../../../assets/images/icons/trash.svg';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import hideCpf from '../../../../utils/hideCpf';
import hideEmail from '../../../../utils/hideEmail';
import { HandleOpenDeleteModalInterface, MappedClientUserType } from '../../types';
import {
  Card,
} from './styles';

interface ListInterface {
  filteredList: MappedClientUserType[];
  onOpenDeleteModal: ({ name, clientUserCode }: HandleOpenDeleteModalInterface) => void;
}

export default function List({
  filteredList,
  onOpenDeleteModal,
}: ListInterface) {
  const typeColorLiterals = {
    Administrador: '',
    Padrão: 'green',
    Motorista: 'orange',
  };
  const { permissions } = useGetGeneralAppData();
  const clientUsersPermissions = permissions.find((x) => x.codPag === 3);

  return (
    <Container>
      <Row xs={1} md={2} lg={2}>
        {filteredList?.map((user) => (
          <Col key={user.userCode}>
            <OpacityAnimation>
              <Card title="Expandir detalhes e editar">
                <div className="info">
                  <div className="card-title">
                    <strong>{user.name}</strong>
                    <small className={typeColorLiterals[user.type]}>
                      {user.type}
                    </small>
                  </div>
                  <span>
                    CPF:
                    {' '}
                    {hideCpf(user.cpf) || 'Não informado'}
                  </span>
                  <span>
                    E-mail:
                    {' '}
                    {hideEmail(user.email) || 'Não informado'}
                  </span>
                  <span>
                    Tipo:
                    {' '}
                    {user.type}
                  </span>
                </div>
                <div className="actions">
                  {clientUsersPermissions?.alterar && (
                    <Link to={`/clientUsers/${user.userCode}`}>
                      <img src={edit} alt="" title={`Editar usuário ${user.name}`} className="primaryColor" />
                    </Link>
                  )}
                  {clientUsersPermissions?.excluir && (
                    <button
                      type="button"
                      onClick={() => onOpenDeleteModal({
                        name: user.name,
                        clientUserCode: user.userCode,
                      })}
                    >
                      <img src={trash} alt="" title='Remover usuário' />
                    </button>
                  )}
                </div>
              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
